define.alias("shared/components/shared/choose-your-upgrade", "media/components/shared/choose-your-upgrade");